export class TVProvider {
    constructor(props) {
        this.providerID = props.ID;
        this.providerName = props.displayName;
        this.providerLogo = props.logo;
        this.providerLogoBlack = props.logoBlack;
        this.tier = props.tier;
    }
}

export let createTVProviderObj = (provider, configs) => {
    let p = findProvider(provider, configs);

    if (p !== false) {
        return new TVProvider({
            ID: provider.ID,
            displayName: p.adobe_display_name_override || provider.displayName,
            logoBlack: p.filepath_adobe_logo_black_override,
            logo: p.filepath_adobe_logo_white_override,
            tier: p.tier
        });
    }

    return null;
};

function findProvider(provider, list) {
    for (let p of list) {
        if (p.adobe_id === provider.ID) {
            return p;
        }
    }

    return false;
}
